import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { startCase } from 'lodash';
import { PredefinedJurisdiction } from '/@/modules/predefined/enums/PredefinedJurisdiction';
import { FeatureFlagKey } from '@/modules/admin/constants/FeatureFlagKey';

export class FeatureFlag extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  key;

  /**
   * @var {string}
   */
  description;

  /**
   * @var {array}
   */
  tags;

  /**
   * @var {object}
   */
  environments;

  /**
   * @var {FeatureFlagJurisdiction[]}
   */
  featureFlagJurisdictions;

  /**
   * @var {FeatureFlagEstateType[]}
   */
  featureFlagEstateTypes;

  /**
   * @var {boolean}
   */
  value;

  constructor(model = {}) {
    super(model);
    super.setRelationships(this, model, this.getModelName());

    this.id = model.id;
    this.name = model.name;
    this.key = model.key;
    this.description = model.description;
    this.tags = model.tags;
    this.environments = model.environments;
    this.value = model.value;
  }

  /**
   *
   * @returns {string}
   */
  getModelName() {
    return ModelType.FEATURE_FLAG;
  }

  get stagingValue() {
    return this.environments.staging;
  }

  get prodValue() {
    return this.environments.production;
  }

  /**
   * @returns {string}
   */
  get prettyKey() {
    return startCase(this.key.replaceAll('_', ' '));
  }

  /**
   * @param countryId
   * @returns {boolean}
   */
  isOverriddenInCountry(countryId) {
    return this.featureFlagJurisdictions.some(
      (featureFlagJurisdiction) =>
        featureFlagJurisdiction.value !== this.value &&
        PredefinedJurisdiction.getByKey(featureFlagJurisdiction.jurisdictionId, 'id').country_id ===
          countryId
    );
  }

  /**
   * @param jurisdictionId
   * @returns {*|boolean}
   */
  getValueInJurisdiction(jurisdictionId) {
    const jurisdictionOverride = this.featureFlagJurisdictions.find(
      (featureFlagJurisdiction) => featureFlagJurisdiction.jurisdictionId === jurisdictionId
    );

    return jurisdictionOverride?.value ?? this.value;
  }

  get isEnabled() {
    return this.value === true;
  }

  get isCanAccessSettlementOnboarding() {
    return this.key === FeatureFlagKey.CAN_ACCESS_SETTLEMENT_ONBOARDING;
  }

  get isCanAccessVaultOnboardingFlow() {
    return this.key === FeatureFlagKey.CAN_ACCESS_VAULT_ONBOARDING_FLOW;
  }

  get isCanMigrateGuidedPlan() {
    return this.key === FeatureFlagKey.CAN_MIGRATE_GUIDED_PLAN;
  }
}
